// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.premiumAdminEditUserMenu h5 {
  font-size: 14px;
  font-weight: bold;
}

.premiumAdminEditUserMenu .radio {
  float: left;
  margin-right: 25px;
}

.premiumAdminEditUserMenu .form-group .radioHolder {
  overflow: hidden;
}

.premiumAdminEditUserMenu .edit-user-actions .action .spinner {
  margin: 0;
}

.enrollmentInput {
  width: 55px;
  display: inline;
  margin-right: 5px;
}

.radioEnrollments {
  margin-left: 0px !important;
  margin-right: 25px;
}

.rosterSaveSpinner .spinner {
  margin: 0px 65px 15px 0px !important;
  height: 40px !important;
}

.rosterNote {
  margin-top: 40px;
  margin-left: -15px;
  margin-bottom: 5px;
}

.sessionTitle {
  margin-top: -15px;
  margin-bottom: 15px;
  font-size: 14px;
  padding-top: 0.5em;
}

.cpCourseCursor {
  cursor: pointer;
  user-select: none;
}

.cpOrderIcon {
  margin-right: 15px;
  float: left;
}

#imageSelectionModal .imgSelectionContainer {
  background-color: white;
  max-height: 500px;
  overflow-x: hidden;
}

#imageSelectionModal .mainImage {
  display: block;
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
  width: 40%;
}

#imageSelectionModal .firstRow {
  margin-top: 70px;
  max-height: 300px;
  overflow-y: scroll;
  overflow-x: hidden;
}
#imageSelectionModal .title-class {
  border-bottom: 1px solid #a9a9a9;
  height: 35px;
  font-weight: 700;
  margin-top: 20px;
}

#imageSelectionModal .tileImage {
  max-width: 100%;
  max-height: 100%;
  border: solid;
  border-color: white;
  border-width: 3px;
}
#imageSelectionModal .tileImage:hover {
  border-color: #a1a1a1;
}
#imageSelectionModal .selected {
  border-color: #0078c1;
}

.offeringSession {
  background-color: white;
  padding-left: 0px;
  padding-right: 0px;
  border-right: 15px solid #e5e5e5;
  border-left: 15px solid #e5e5e5;
}

#edit-course-form label,
h5,
.btn {
  text-transform: capitalize;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/courses/admin.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;;;EAGE,0BAA0B;AAC5B","sourcesContent":[".premiumAdminEditUserMenu h5 {\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.premiumAdminEditUserMenu .radio {\n  float: left;\n  margin-right: 25px;\n}\n\n.premiumAdminEditUserMenu .form-group .radioHolder {\n  overflow: hidden;\n}\n\n.premiumAdminEditUserMenu .edit-user-actions .action .spinner {\n  margin: 0;\n}\n\n.enrollmentInput {\n  width: 55px;\n  display: inline;\n  margin-right: 5px;\n}\n\n.radioEnrollments {\n  margin-left: 0px !important;\n  margin-right: 25px;\n}\n\n.rosterSaveSpinner .spinner {\n  margin: 0px 65px 15px 0px !important;\n  height: 40px !important;\n}\n\n.rosterNote {\n  margin-top: 40px;\n  margin-left: -15px;\n  margin-bottom: 5px;\n}\n\n.sessionTitle {\n  margin-top: -15px;\n  margin-bottom: 15px;\n  font-size: 14px;\n  padding-top: 0.5em;\n}\n\n.cpCourseCursor {\n  cursor: pointer;\n  user-select: none;\n}\n\n.cpOrderIcon {\n  margin-right: 15px;\n  float: left;\n}\n\n#imageSelectionModal .imgSelectionContainer {\n  background-color: white;\n  max-height: 500px;\n  overflow-x: hidden;\n}\n\n#imageSelectionModal .mainImage {\n  display: block;\n  margin-top: 10px;\n  margin-left: auto;\n  margin-right: auto;\n  width: 40%;\n}\n\n#imageSelectionModal .firstRow {\n  margin-top: 70px;\n  max-height: 300px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n#imageSelectionModal .title-class {\n  border-bottom: 1px solid #a9a9a9;\n  height: 35px;\n  font-weight: 700;\n  margin-top: 20px;\n}\n\n#imageSelectionModal .tileImage {\n  max-width: 100%;\n  max-height: 100%;\n  border: solid;\n  border-color: white;\n  border-width: 3px;\n}\n#imageSelectionModal .tileImage:hover {\n  border-color: #a1a1a1;\n}\n#imageSelectionModal .selected {\n  border-color: #0078c1;\n}\n\n.offeringSession {\n  background-color: white;\n  padding-left: 0px;\n  padding-right: 0px;\n  border-right: 15px solid #e5e5e5;\n  border-left: 15px solid #e5e5e5;\n}\n\n#edit-course-form label,\nh5,\n.btn {\n  text-transform: capitalize;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
